/**
 * One Mintlify-style MDX block the v2 markdown reader turns into editor HTML.
 * `pattern` must be global; `render` gets the match and a parser for any
 * markdown body the block holds, already one level deeper.
 */
export interface MdxBlockReader {
	name: string
	pattern: RegExp
	render: (
		match: RegExpMatchArray,
		parseBody: (markdown: string) => string,
	) => string
}

export const MDX_BLOCK_READERS: MdxBlockReader[] = []
